import * as yup from 'yup';

export const initialValuesForm = (eventCard = {}, companyBonuses, allCities) => {
  const currentServices = companyBonuses?.find(({ id }) => id === eventCard?.service?.company?.id);

  const updateCardIsEmpty = !Object.values(eventCard).length;

  const cities = eventCard?.cities?.map(city => ({ label: city?.name, value: city?.id })) || [];
  const initialCities = cities.length === allCities?.length ? [{ label: 'Все', value: 'all' }, ...cities] : cities;

  return {
    add_if_debt_exist: typeof eventCard.add_if_debt_exist === 'boolean' ? eventCard.add_if_debt_exist : true,
    trigger: eventCard.trigger || '',
    date_start: eventCard.date_start || '',
    date_end: eventCard.date_end || '',
    date_expiry: eventCard.date_expiry || '',
    bonus_add: eventCard.bonus_add,
    terms: eventCard.terms || '',
    to_all_customer: updateCardIsEmpty ? true : eventCard.to_all_customer,
    customer_files: eventCard.customer_files || [],
    company: updateCardIsEmpty
      ? ''
      : {
        ...eventCard?.service?.company,
        services: currentServices?.services
      },
    service_id: eventCard.service
      ? { id: eventCard?.service?.id, name: eventCard?.service?.name }
      : '',
    package_id: eventCard.package
      ? { id: eventCard?.package?.id, name: eventCard?.package?.name }
      : '',
    // UNDONE: Temporary not showing, Task=382736
    // packages_validation: eventCard.packages_validation
    //   ? { name: get(eventCard, 'packages_validation[0]') }
    //   : '',
    // activation_conditions: eventCard.activation_conditions
    //   ? { code: get(eventCard, 'activation_conditions[0]') }
    //   : '',
    city_id: initialCities,
    customers_limit: eventCard.customers_limit || '',
  };
};

export const dataCreateEvent = (values, uploadFiles, customTouched, isById, ENTITY, isAllTouched, cities) => {

  const toAllSubscribers = () => {
    return values?.trigger?.slug === 'retention' ? false :
      typeof values?.to_all_customer === 'boolean'
        ? values?.to_all_customer
        : values?.to_all_customer === ENTITY[0].value;
  };

  const subscribersFiles = () => {
    return values?.customer_files
      ? values?.customer_files.map((file) =>
        file.id
          ? file.id
          : uploadFiles.find((newFile) => newFile.data.instance.file_name === file.name)?.data
            ?.instance?.id
      )
      : [];
  };

  const setDateExpiry = () => {
    const date = values?.date_expiry ? new Date(values?.date_expiry) : new Date();
    date.setHours(23,59,59);
    return date;
  };

  const setDateEnd = () => {
    const date = values?.date_end ? new Date(values?.date_end) : new Date();
    date.setHours(23,59,59);
    return date;
  };

  const participantsAdd = () => {
    if (typeof values?.customers_limit === 'string') {
      return values?.customers_limit ?
        Number(values.customers_limit.replace(/ /g, '')) :
        undefined;
    }

    return values?.customers_limit;
  };

  const setCityId = () => {
    if (!values?.city_id?.length) return [0];
    if (values?.city_id?.findIndex(city => city.value === 'all') > -1) return cities.map(city => city?.value);
    return values?.city_id?.map(city => city?.value);
  };

  const fields = {
    date_start: new Date(values?.date_start),
    date_end: setDateEnd(),
    date_expiry: setDateExpiry(),
    service_id: values?.service_id?.id,
    package_id: values?.package_id?.id,
    trigger_id: values?.trigger?.id,
    terms: values?.terms,
    bonus_add: values?.bonus_add ? Number(values?.bonus_add) : 0,
    add_if_debt_exist: values.add_if_debt_exist,
    // UNDONE: Temporary mocked, Task=382736
    // packages_validation: [values?.packages_validation?.name],
    // activation_conditions: [values?.activation_conditions?.code],
    packages_validation: [],
    activation_conditions: [],
    city_id: setCityId(),
    customer_files: subscribersFiles(),
    to_all_customer: toAllSubscribers(),
    customers_limit: values.trigger.slug === 'retention' ? participantsAdd() : 0,
    universal_promocode: values?.universal_promocode,
    site_url: values?.site_url
  };

  const updatesFields = Object.keys(fields).reduce((acc, item) => {
    customTouched[item] || isAllTouched ? (acc[item] = fields[item]) : {};
    return acc;
  }, {});

  if (isById && customTouched.trigger_id) {
    switch (values.trigger.slug) {
      case 'crm':
        updatesFields.city_id = [];
        updatesFields.customers_limit = 0;
        updatesFields.package_id = null;
        updatesFields.to_all_customer = true;
        break;
      case 'welcome':
        updatesFields.customers_limit = 0;
        break;
      case 'active':
        updatesFields.city_id = [];
        updatesFields.customers_limit = 0;
        break;
      case 'retention':
        updatesFields.city_id = [];
        break;
    }
  }

  return isById ? updatesFields : fields;
};

export const validationSchema = (isDisabled = false) => yup.object().shape({
  trigger: yup.object().required(),
  date_start: isDisabled ?
    yup.date() :
    yup.date()
      .min(new Date(), () => ({
        dateStartNotValid: 'Дата старта не может быть раньше текущей'
      }))
      .required(),
  date_end: isDisabled ?
    yup.date() :
    yup.date()
      .transform((date) => date.setHours(23,59,59))
      .min(yup.ref('date_start'), () => ({
        dateEndNotValid: 'Дата окончания не может быть ранее Даты начала',
      }))
      .transform((date) => new Date(date))
      .required(),
  date_expiry: isDisabled ?
    yup.date() :
    yup.date()
      .transform((date) => date.setHours(23,59,59))
      .min(yup.ref('date_end'), () => ({
        dateExpiryNotValid: 'Дата окончания больше, чем дата срока действия бонусов'
      }))
      .transform((date) => new Date(date))
      .required(),
  //account_number: yup.string().required(),
  // UNDONE: Temporary not showing, Task=382736
  // activation_conditions: yup.object().when('trigger', {
  //   is: (val) => (val?.slug === 'active'),
  //   then: yup.object().required(),
  //   otherwise: yup.object(),
  // }),
  // packages_validation: yup.object().when('trigger', {
  //   is: (val) => (val?.slug === 'active'),
  //   then: yup.object().required(),
  //   otherwise: yup.object(),
  // }),
  company: yup.object().required(),
  service_id: yup.object().required(),
  package_id: yup.object().when('trigger', {
    is: (val) => (val?.slug !== 'crm'),
    then: yup.object().required(),
    otherwise: yup.object(),
  }),
  terms: yup.string().max(1000, 'До 1000 символов').required(),
  bonus_add: yup.number()
    .test('numbers', 'Допустимы только цифры', value => !value || /^[0-9]+$/.test(value))
    .test('lessThanTen', () => ({ bonusesLimit: 'Поле “Количество бонусов” должно содержать не более 9 символов' }), value => !value || value.toString().length < 10)
    .required('Обязательное поле'),
  customer_files: yup.array().when('trigger', {
    is: (val) => (val?.slug === 'retention'),
    then: yup.array().min(1, 'one files min').required(),
    otherwise: yup.array().when('to_all_customer', {
      is: (val) => (typeof val === 'boolean' ? !val : val === 'files'),
      then: yup.array().min(1, 'one files min').required(),
      otherwise: yup.array()
    })
  }),
  customers_limit: yup.number().when('trigger', {
    is: (val) => (val?.slug === 'retention'),
    then: yup.number().min(1, () => ({
      customersLimitError: 'Количество абонентов не может быть равным 0'
    })).required(),
  }),
  city_id: yup.array().when('trigger', {
    is: (val) => (val?.slug === 'welcome'),
    then: yup.array().test('cities', 'Не пустой список', value => value.length),
    otherwise: yup.array().nullable(),
  }),
});

export const validationFiles = (newFile, currentFiles) => {
  if (currentFiles?.length > 49) {
    return {
      code: 'length',
      message: `Не более 50 файлов`
    };
  }

  if (newFile.size > 10 * 1024 * 1024) {
    return {
      code: 'size',
      message: `Не более 10мб`
    };
  }
};
